import companyService from '@/@libs/services/companyService/companyService';

export default companyService;
